<div class="seguridad-header">
    <div class="seguridad-header__accent"></div>
    <div class="container seguridad-header__inner">
        <span class="material-icons seguridad-header__icon">{{ icon }}</span>
        <div>
            <h1 class="seguridad-header__title">
                {{ title }}<span *ngIf="highlight">&nbsp;{{ highlight }}</span>
            </h1>
            <p class="seguridad-header__subtitle" *ngIf="subtitle">{{ subtitle }}</p>
        </div>
    </div>
</div>
